/**
 * VisionARSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait VisionARSiteHeaderLanguages
 */

import { useVisionARSiteHeaderLanguagesLogic } from '@/hooks/traits/useVisionARSiteHeaderLanguagesLogic';
import type { VisionARSiteHeaderLanguagesConfig } from '@/hooks/traits/useVisionARSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { VisionARVisionView as VisionARVisionViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface VisionARSiteHeaderLanguagesViewProps {
  config?: Partial<VisionARSiteHeaderLanguagesConfig>;
}

export function VisionARSiteHeaderLanguagesView({ config: propsConfig }: VisionARSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useVisionARSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['VisionARVisionView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="VisionAR" trait="VisionARSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu position="bottom-end" trigger={<Button variant="ghost" icon="globe" size="sm" label={String(__locale.toUpperCase())} />} items={Array.isArray(([{ href: "/vision" as const, code: "en" as const, label: "English" as const }, { href: "/ar/vision" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/vision" as const, code: "sl" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) ? (((([{ href: "/vision" as const, code: "en" as const, label: "English" as const }, { href: "/ar/vision" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/vision" as const, code: "sl" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} className={((([{ code: "en" as const, href: "/vision" as const, label: "English" as const }, { href: "/ar/vision" as const, label: "العربية" as const, code: "ar" as const }, { href: "/sl/vision" as const, label: "Slovenščina" as const, code: "sl" as const }]).length === 0)) ? "hidden" : ""} />) : null}
    </TraitScopeProvider>
  );
}

export default VisionARSiteHeaderLanguagesView;
